// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2FxkC","rotateAnim":"Spinner_rotateAnim__1sfB4"};